<template>
  <header class="embedded-header">
    <div class="embedded-wrapper" :key="embedCompanyLogo">
      <img
        :alt="company"
        class="company-logo"
        height="82px"
        :src="embedCompanyLogo"
      />
      <img
        alt="PSL logo"
        class="psl-logo"
        height="56px"
        src="@/assets/images/Payment-Shield-Insurance1.png"
      />
    </div>
  </header>
</template>

<script>
import { API_GET_EMBED_LOGO } from "@/constants/api.constants";
import { pslClient } from "@/common/http-common";

export default {
  name: "EmbedFooter",

  data() {
    return {
      embedCompanyLogo: null,
    };
  },

  props: {
    company: {
      type: String,
      required: true,
    },
  },

  async mounted() {
    this.embedCompanyLogo = await this.getCompany();
  },

  methods: {
    async getCompany() {
      if (!this.company) return "";
      let res = await pslClient.get(`${API_GET_EMBED_LOGO}/${this.company}`);
      return res?.data?.Data || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.embedded-header {
  width: 100%;
  height: 100px;
  padding: 9px 0px;
  margin-bottom: 10px;
  background-color: $white !important;
  z-index: 1;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;

  .embedded-wrapper {
    max-width: 1080px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    height: 100%;
  }
}

@media screen and (max-width: 1096px) {
  .embedded-header {
    padding: 9px 16px;
  }
}
</style>
